import styled from "styled-components";
import { UINavItemStyle } from "jecko-components/nav/UINavItem";
import { Link } from "gatsby";

export default styled(Link)`
  ${UINavItemStyle}
`;
